
import {defineComponent, onMounted, provide, ref} from "vue"
import {fetchMap, createMapStore, fetchEviglance} from "@/mixins/mapStore";
import Loading from "@/components/Loading.vue";
import GraphView from "@/views/GraphView.vue";
import TabularView from "@/views/TabularView.vue";
import Search from "@/components/Search.vue";

enum EDisplayState {
  Select, Loading, Ggraph, Tabular, Error
}

export default defineComponent({
  name: "app",
  components: { Search, GraphView, Loading, TabularView},
  setup() {
    const displayState = ref(EDisplayState.Loading)
    const selectMap = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const l_Map = await fetchMap(urlParams.get("map"))
        const l_Eviglance = await fetchEviglance();

        // console.log(l_Map)
        // console.log(l_Eviglance)
        mapStore.state.map = l_Map
        mapStore.state.about = l_Eviglance["about"]
        mapStore.state.instructionsMap= l_Eviglance["instructionPathWebMap"]
        mapStore.state.instructionsTabular= l_Eviglance["instructionPathWebTab"]
        displayState.value = EDisplayState.Ggraph;
      } catch (e) {
        console.log(e)
        displayState.value = EDisplayState.Error
      }
    }
    const mapStore = createMapStore();
    provide("mapStore", mapStore)
    selectMap()
    return {
      displayState,
      EDisplayState,
      mapStore
    }
  }
})
